/**
 * Нормализует числовые значения из БД, конвертируя строки в числа
 * СОХРАНЯЕТ ПОЛНУЮ ТОЧНОСТЬ данных, только преобразует тип
 * 
 * @param value - значение из БД (может быть строкой типа "293.236619" или "329605200.000000", или числом)
 * @returns число с полной точностью или исходное значение если это не число
 * 
 * @example
 * normalizeNumericValue("293.000000") // 293 (число)
 * normalizeNumericValue("293.236619") // 293.236619 (число, полная точность сохранена)
 * normalizeNumericValue("329605200.000000") // 329605200 (число)
 * normalizeNumericValue(293.24) // 293.24 (число как есть)
 */
export function normalizeNumericValue(value: string | number | null | undefined): string | number | null | undefined {
  if (value === null || value === undefined || value === '') {
    return value;
  }

  // Если это уже число, возвращаем как есть (полная точность)
  if (typeof value === 'number') {
    return value;
  }

  // Если это строка, парсим в число (сохраняя точность)
  if (typeof value === 'string') {
    const trimmed = value.trim();
    
    // Проверяем что это валидное число
    if (trimmed === '' || isNaN(Number(trimmed))) {
      return value; // Возвращаем исходную строку если это не число
    }

    const num = parseFloat(trimmed);
    
    // Если после парсинга получилось NaN или Infinity
    if (!isFinite(num)) {
      return value;
    }

    // Возвращаем число с полной точностью (parseFloat сам убирает незначащие нули)
    return num;
  }

  return value;
}

/**
 * Форматирует число для отображения в тултипе (показывает полное значение с полной точностью)
 * 
 * @param value - исходное значение
 * @returns строка для отображения в тултипе с полной точностью
 * 
 * @example
 * getFullNumericValue(293.236619) // "293.236619"
 * getFullNumericValue(293) // "293"
 * getFullNumericValue("329605200.000000") // "329605200"
 */
export function getFullNumericValue(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  if (typeof value === 'number') {
    // Для чисел показываем полное значение
    // Используем toLocaleString с максимальной точностью чтобы сохранить все десятичные знаки
    return value.toString();
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    // Возвращаем строку как есть, чтобы показать полную точность из БД
    return trimmed;
  }

  return String(value);
}


